import React from "react";
import styled from "styled-components";
// Animations
import { motion } from "framer-motion";
import { pageAnimation, titleAnimation } from "../animation";
import { Hide } from "../styles";

const GoalsStyle = styled(motion.section)`
  padding: 5rem;
  max-height: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  color: #f1ec0a;
  background-color: #ff1a1a;
  /* Kindel and iPad tablet  */
  @media only screen and (min-width: 540px) and (max-width: 820px) {
    padding: 5rem 2rem;
  }
  /* Mobile devices iPhone, Pixel */
  @media only screen and (min-width: 320px) and (max-width: 539px) {
    padding: 1.5rem;
    max-height: fit-content;
    height: 100%;
  }
`;

const GoalsTitle = styled(motion.div)`
  width: 100%;
  h4 {
    color: #f1ec0a;
    font-size: 4rem;
  }
  p {
    color: #f1ec0a;
  }
  /* Kindel and iPad tablet  */
  @media only screen and (min-width: 540px) and (max-width: 820px) {
    h4 {
      font-size: 3.6rem;
    }
  }
  /* Mobile devices iPhone, Pixel */
  @media only screen and (min-width: 320px) and (max-width: 539px) {
    h4 {
      font-size: 2.5rem;
    }
    p {
      font-size: 1rem;
    }
  }
`;

const OurGoals = () => {
  return (
    <GoalsStyle
      variants={pageAnimation}
      initial="hidden"
      animate="show"
      exit="exit"
    >
      <GoalsTitle variants={titleAnimation}>
        <Hide>
          <motion.h4>Our Goals</motion.h4>
          <motion.p>
            Burgred is poised for rapid expansion, with plans to open four new branches in the next two years—two in key Algerian cities (Algiers, Oran) and two in high-demand Gulf markets (Doha and Jeddah). Our strategy focuses on localized menu adaptations, strong brand marketing, and consistent quality control to drive customer loyalty. With a clear focus on efficiency, from sourcing to logistics, Burgred aims for rapid market penetration and profitability within the first year of operations in each location. This expansion offers significant growth potential in two dynamic regions.
          </motion.p>
        </Hide>
      </GoalsTitle>
    </GoalsStyle>
  );
};

export default OurGoals;
